module.exports = __webpack_public_path__ + "static/media/general-chemistry.f535dd34.svg";